import type { To } from 'react-router';

import type { GoBackOneEntry } from '#src/lib/routing.tsx';
import { hasPreviousLocation } from '#src/lib/routing.tsx';

export const getSafePreviousLocation = (
  defaultPreviousLocation: To
): To | GoBackOneEntry => {
  if (hasPreviousLocation()) {
    return -1;
  }
  return defaultPreviousLocation;
};
